export function normalizeTimestampValue(value: unknown): Date | false {
    if (value instanceof Date) {
        return isNaN(value.getTime()) ? false : value
    }

    if (typeof value === 'string') {
        const trimmed = value.trim()

        if (trimmed === '' || /^-?\d+$/.test(trimmed)) {
            return false
        }

        const date = new Date(trimmed)

        return isNaN(date.getTime()) ? false : date
    }

    if (typeof value === 'number') {
        if (!Number.isFinite(value) || value <= 0) {
            return false
        }

        const date = new Date(value)

        return isNaN(date.getTime()) ? false : date
    }

    return false
}

export default normalizeTimestampValue
